<ng-container *ngFor="let site of siteData | async">
    <button color="primary" mat-raised-button class="loc" type="button" label="Click" id={{site.Site}} (click)="handleClick(site.Site)">{{site.display_name}}</button>
</ng-container>